import {
  UPDATE_DPR_SKIP_STATE,
  RESET_DPR_SKIP_STATES,
  LOAD_DPR_SKIP_STATES_FOR_SECTION,
  UPDATE_DPR_SAVED_STATE
} from './types';

const initialState = {
  currentSowId: null,
  skipStatesBySection: {}, // { sowId: { skipSafety: false, skipQuality: false, ... } }
  savedStatesBySection: {} // { sowId: { savedSafety: false, savedQuality: false, ... } }
};

const dprReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DPR_SKIP_STATE:
      const { sowId, section, value } = action.payload;
      if (!sowId) return state;
      
      return {
        ...state,
        skipStatesBySection: {
          ...state.skipStatesBySection,
          [sowId]: {
            ...(state.skipStatesBySection[sowId] || {}),
            [section]: Boolean(value)
          }
        }
      };
    case LOAD_DPR_SKIP_STATES_FOR_SECTION:
      const { sowId: loadSowId } = action.payload;
      return {
        ...state,
        currentSowId: loadSowId
      };
    case UPDATE_DPR_SAVED_STATE:
      const { sowId: savedSowId, section: savedSection, value: savedValue } = action.payload;
      if (!savedSowId) return state;

      return {
        ...state,
        savedStatesBySection: {
          ...state.savedStatesBySection,
          [savedSowId]: {
            ...(state.savedStatesBySection[savedSowId] || {}),
            [savedSection]: Boolean(savedValue)
          }
        }
      };
    case RESET_DPR_SKIP_STATES:
      return {
        ...state,
        currentSowId: null,
        skipStatesBySection: {},
        savedStatesBySection: {}
      };
    default:
      return state;
  }
};

export default dprReducer;

